'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;
exports.getCUMajorType = getCUMajorType;
var GET_CUMAJOR_TYPE = 'major/cumajor_types/GET_CUMAJOR_TYPE';
var GET_CUMAJOR_TYPE_SUCCESS = 'major/cumajor_types/GET_CUMAJOR_TYPE_SUCCESS';
var GET_CUMAJOR_TYPE_FAIL = 'major/cumajor_types/GET_CUMAJOR_TYPE_FAIL';

var INIT_MAJOR_TYPE = '/major/cumajor_type/INIT_MAJOR_TYPE';

var initialState = {
    majorType: {
        description: '',
        name: '',
        majors: []
    },
    loading: false
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case GET_CUMAJOR_TYPE:
            return _extends({}, state, {
                loading: true
            });
        case GET_CUMAJOR_TYPE_SUCCESS:
            if (!action.result.data.success) {
                return _extends({}, state, {
                    loading: false
                });
            }
            return _extends({}, state, {
                majorType: action.result.data.data,
                loading: false
            });
        case GET_CUMAJOR_TYPE_FAIL:
            return _extends({}, state, {
                loading: false
            });
        default:
            return state;
    }
}

function getCUMajorType(majorTypeCode) {
    return {
        types: [GET_CUMAJOR_TYPE, GET_CUMAJOR_TYPE_SUCCESS, GET_CUMAJOR_TYPE_FAIL],
        promise: function () {
            function promise(client) {
                return client.get('/api/major/' + majorTypeCode);
            }

            return promise;
        }()
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/reducers/major/cumajorType.js
// module id = 491
// module chunks = 0